import { render, staticRenderFns } from "./PullActivityDetail.vue?vue&type=template&id=a836434e&scoped=true"
import script from "./PullActivityDetail.vue?vue&type=script&lang=js"
export * from "./PullActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./PullActivityDetail.vue?vue&type=style&index=0&id=a836434e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a836434e",
  null
  
)

export default component.exports